import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import styled from 'styled-components';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIStatusDot from 'UIComponents/tag/UIStatusDot';
import { EERIE, OLAF, GYPSUM, KOALA } from 'HubStyleTokens/colors';
import { BOT, SYSTEM } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';
import SkeletonCircle from 'conversations-skeleton-state/components/SkeletonCircle';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { mrHubBot } from 'conversations-message-history/constants/images';
import { getNonDefaultSource, getSenderType, getDisplayName } from 'conversations-message-history/senders/operators/getters';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../M... Remove this comment to see the full error message
import MessageHistoryContext from '../MessageHistoryContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UIAVATAR_SIZE = 32;
const SenderAvatarWrapper = styled.div.withConfig({
  displayName: "SenderAvatar__SenderAvatarWrapper",
  componentId: "sc-9cqluf-0"
})(["position:relative;"]);
const StyledUIIcon = styled(UIIcon).withConfig({
  displayName: "SenderAvatar__StyledUIIcon",
  componentId: "sc-9cqluf-1"
})(["width:", "px;height:", "px;font-size:24px !important;text-align:center;line-height:", "px;border-radius:", "px;background-color:", ";color:", ";"], UIAVATAR_SIZE, UIAVATAR_SIZE, UIAVATAR_SIZE, UIAVATAR_SIZE / 2, EERIE, OLAF);
export const StatusDot = styled(UIStatusDot).withConfig({
  displayName: "SenderAvatar__StatusDot",
  componentId: "sc-9cqluf-2"
})(["position:absolute;bottom:4px;right:-1px;border:2px solid ", ";height:12px !important;width:12px !important;margin-right:0;"], GYPSUM);
export default class SenderAvatar extends PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  hasClickHandler() {
    const {
      onClick
    } = this.props;
    return Boolean(onClick);
  }
  handleClick() {
    const {
      onClick,
      sender
    } = this.props;
    if (onClick) onClick(sender);
  }
  renderAvatar() {
    const {
      isLoading,
      sender,
      size
    } = this.props;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'AvatarComponent' does not exist on type ... Remove this comment to see the full error message
    const {
      AvatarComponent
    } = this.context;
    const commonAvatarProps = {
      size,
      _isHasTooltip: !this.hasClickHandler()
    };
    if (isLoading) {
      return /*#__PURE__*/_jsx(SkeletonCircle, {
        "data-test-id": "skeleton-circle-avatar",
        size: UIAVATAR_SIZE,
        use: "on-shade"
      });
    }
    if (!sender) {
      return /*#__PURE__*/_jsx("span", {
        "data-test-id": "unknown-avatar-wrapper",
        children: /*#__PURE__*/_jsx(AvatarComponent, Object.assign({}, commonAvatarProps, {
          "data-test-id": "unknown-avatar-wrapper"
        }))
      });
    }
    const senderType = getSenderType(sender);
    switch (senderType) {
      case BOT:
        {
          const StyledAvatarComponent = styled(AvatarComponent).withConfig({
            displayName: "SenderAvatar__StyledAvatarComponent",
            componentId: "sc-9cqluf-3"
          })(["background:", ";border-radius:50%;svg{background-size:20px;background-repeat:no-repeat;}"], KOALA);
          return /*#__PURE__*/_jsx("span", {
            "data-test-id": "bot-avatar-wrapper",
            children: /*#__PURE__*/_jsx(StyledAvatarComponent, Object.assign({}, commonAvatarProps, {
              src: mrHubBot
            }))
          });
        }
      case SYSTEM:
        return /*#__PURE__*/_jsx(StyledUIIcon, {
          "data-test-id": "system-sender-avatar",
          name: "simpleBot"
        });
      default:
        return /*#__PURE__*/_jsx("span", {
          "data-test-id": "sender-avatar-wrapper",
          onClick: this.handleClick,
          children: /*#__PURE__*/_jsx(AvatarComponent, Object.assign({}, commonAvatarProps, {
            _isHasTooltip: false,
            type: "contact",
            src: getNonDefaultSource(sender),
            displayName: getDisplayName(sender)
          }))
        });
    }
  }
  render() {
    const {
      present
    } = this.props;
    return /*#__PURE__*/_jsxs(SenderAvatarWrapper, {
      onClick: this.handleClick,
      children: [this.renderAvatar(), present && /*#__PURE__*/_jsx(StatusDot, {
        "data-test-id": "status-dot",
        use: "oz"
      })]
    });
  }
}
SenderAvatar.displayName = 'SenderAvatar';
SenderAvatar.propTypes = {
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  present: PropTypes.bool,
  sender: RecordPropType('Sender'),
  size: PropTypes.string
};
SenderAvatar.defaultProps = {
  size: 'sm'
};
SenderAvatar.contextType = MessageHistoryContext;